<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @print="print" @save="save" @del="del" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="PurReceiveViewInfo"
                        :filter_language="['Order_Status']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleCurrentChanges="handleCurrentChanges"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :row-class-name="tableRowClassName"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        @current-change="handleCurrentChanges"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassName"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_No" :label="$t('getapi[463]')">
                        <template scope="scope">
                            <input
                                    type="text"
                                    class="fsd clerinput"
                                    @keydown="keydown($event, scope.$index)"
                                    @keyup="keyup($event, scope.row)"
                                    v-model="scope.row.order_No"
                                    readonly
                            />
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Relation_PO_Code"
                                     :label="$t('getapi[1710]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="delive_order_No"
                                     :label="$t('getapi[1744]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="receive_person"
                                     :label="$t('getapi[1745]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="receive_Time"
                                     :label="$t('getapi[1746]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person"
                                     :label="$t('getapi[4470]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_Time"
                                     :label="$t('getapi[1748]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Status"
                                     :label="$t('getapi[552]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="transact_person"
                                     :label="$t('getapi[1167]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                 <!-- <div style="height:30px" class="btnnowrap"> -->
                    <el-button type="primary" size="mini" @click="closebill" :disabled="!btn.close" >{{ $t('getapi[441]')}}</el-button>
                 
                <div style="width:840px">
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[463]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.order_no" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[3757]') }}</td>
                            <td style="width:150px;">
                                <routejump :urlNo="29"  v-show="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.Head.relation_po_code"
                                        type="text"
                                        readonly
                                        size="mini"
                                        class="mcolor"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectOrder()"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.Head.relation_po_code" v-show="addoredit != 1" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[1744]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.delive_order_no" type="text" size="mini" v-show="addoredit == 1" class="mcolor"></el-input>
                                <el-input v-model="dataDetail.Head.delive_order_no" type="text" size="mini" v-show="addoredit != 1" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[552]') }}</td>
                            <td style="width:150px;">
                                <el-input :value="expstatus(dataDetail.Head.order_status)" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1287]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.vender_code" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1197]') }}</td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.Head.vender_name" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1745]') }}</td>
                            <td>
                                <!--<el-input v-model="dataDetail.Head.receive_person" type="text" size="mini"></el-input>-->
                                <routejump :urlNo="6" v-show="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.Head.receive_person"
                                        type="text"
                                        readonly
                                        size="mini"
                                        class="mcolor"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(1)"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.Head.receive_person" v-show="addoredit != 1" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[1746]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.receive_time" type="date" size="mini"
                                                style="width:100%" :readonly="addoredit == 2" :class="{'readO':addoredit == 2}"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[1748]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.create_time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[4470]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.create_person" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1103]') }}</td>
                            <td>
                                <routejump :urlNo="46">
                                <el-select filterable v-model="dataDetail.Head.receive_position" size="mini"
                                           :disabled="dataDetail.Head.order_status ==3?true:false">
                                    <el-option v-for="item in recArray" :key="item.Name" :label="item.Name"
                                               :value="item.Name"></el-option>
                                </el-select>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[143]') }}</td>
                            <td colspan="5">
                                <el-input v-model="dataDetail.Head.remark" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
                    <el-tab-pane :label="$t('getapi[1756]')" name="0" id="xdetilpane-0">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="showAddBom('')" :disabled="!btn.add_detail">{{ $t('getapi[6092]') }}
                            </el-button>
                            <el-button type="primary" @click="delline" size="mini" :disabled="!btn.rowdel">{{$t('getapi[686]') }}</el-button>
                            <el-button type="primary" size="mini" @click="allCheck" :disabled="!btn.allcheck">{{
                                $t('getapi[1774]') }}
                            </el-button>
                            <el-button @click="lineCheck" type="primary" size="mini" :disabled="!btn.linecheck">{{$t('getapi[1775]') }}
                            </el-button>
                            <el-button @click="cLineCheck" type="primary" size="mini" :disabled="!btn.canclelincheck">{{$t('getapi[1776]') }}
                            </el-button>
                            <el-button @click="check" type="primary" size="mini" :disabled="!btn.confirmycheck">{{$t('getapi[1777]') }}
                            </el-button>
                            <el-button @click="cCheck" type="primary" size="mini" :disabled="!btn.cancelecheck">{{$t('getapi[1778]') }}
                            </el-button>
                            <el-button @click="mrbCheck" type="primary" size="mini" :disabled="!btn.mrbcheck">{{$t('getapi[12627]') }}
                            </el-button>
                            <el-button @click="sayReturn" type="primary" size="mini" :disabled="!btn.sayreturn">{{$t('getapi[1779]') }}
                            </el-button>
                            <el-button @click="instruction" type="primary" size="mini" :disabled="!btn.instruction">
                                {{$t('getapi[6787]') }}
                            </el-button>
                            <el-button @click="createSerial" type="primary" size="mini" :disabled="!btn.createserial">
                                {{$t('getapi[7121]') }}
                            </el-button>
                            <el-button @click="checkTypeNormal" type="primary" size="mini" :disabled="!btn.checktypemormal">
                                {{$t('getapi[8752]') }}
                            </el-button>
                            <!--<el-button type="primary" size="mini" @click="batchDel">{{ $t('getapi[1522]') }}</el-button>-->
                        </div>
                        <vxe-table
                                :data="dataDetail.LineList"
                                v-loading="dloading"
                                @checkbox-change="handleSelectionChange"
                                :row-class-name="tableRowClassNameDetail"
                                :highlight-current-row="true"
                                style="width: 100%; margin-top:3px"
                                resizable
                                show-overflow="tooltip"
                                :height="tableHeight - 180"
                                header-row-class-name="headerclass"
                                size="mini"
                                border
                                @sort-change="sortChange"
                                :default-sort="sortRule"
                                ref="singleTable1"
                        >
                            <vxe-table-column type="checkbox" align="center"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="row_number" :title="$t('getapi[1425]')" sortable align="right" width="50">
                            </vxe-table-column>
                            <vxe-table-column field="part_code" :title="$t('getapi[226]')" sortable width="120">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.part_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                            v-if="scope.row.line_status == '到达' || scope.row.line_status == ''"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddBom(scope)"></i>
                                    </el-input>
                                    <span v-if="scope.row.line_status != '到达' && scope.row.line_status != ''">{{scope.row.part_code}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_name" :title="$t('getapi[116]')" sortable width="120"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')" sortable width="80"></vxe-table-column>
                            <vxe-table-column field="line_status" :title="$t('getapi[552]')" sortable width="80">
                                <template scope="scope">
                                    <span>{{ scope.row.line_status | lanchange}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="model" :title="$t('getapi[124]')" sortable width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="specification" :title="$t('getapi[125]')" sortable width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_stuff" :title="$t('getapi[126]')" sortable width="80"></vxe-table-column>
                            
                            <vxe-table-column field="batch_no" :title="$t('getapi[1763]')" sortable width="80">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.batch_no" v-if="scope.row.line_status == '到达'  || scope.row.line_status == ''"></el-input>
                                    <span v-if="scope.row.line_status != '到达'  && scope.row.line_status != ''">{{scope.row.batch_no}}</span>
                                </template>
                            </vxe-table-column>

                            <vxe-table-column show-footer-overflow field="sequence_no" :title="$t('getapi[1765]')" sortable width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="freevalue" :title="$t('getapi[8958]')" sortable width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="pur_row_number" :title="$t('getapi[1758]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="order_qty" :title="$t('getapi[1759]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="sums" :title="$t('getapi[1760]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column field="actual_qty" :title="$t('getapi[1761]')" sortable align="right" width="80">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.actual_qty" v-if="scope.row.line_status == '到达'  || scope.row.line_status == ''" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                                    <span v-if="scope.row.line_status != '到达'  && scope.row.line_status != ''">{{scope.row.actual_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="wait_check_qty" :title="$t('getapi[1762]')" sortable align="right" width="80">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.wait_check_qty" v-if="scope.row.line_status == '到达'  || scope.row.line_status == ''" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                                    <span v-if="scope.row.line_status != '到达'  && scope.row.line_status != ''">{{scope.row.wait_check_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="qualify_qty" :title="$t('getapi[1766]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="disqualify_qty" :title="$t('getapi[1767]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="mrb_qty" :title="$t('getapi[12628]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="mrb_qualify_qty" :title="$t('getapi[12633]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="mrb_disqualify_qty" :title="$t('getapi[12634]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="ought_return_qty" :title="$t('getapi[1768]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="returned_qty" :title="$t('getapi[1769]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="pur_measureunit" :title="$t('getapi[1166]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="check_person" :title="$t('getapi[1770]')" sortable width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="check_date" :title="$t('getapi[1771]')" sortable width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="receive_qty" :title="$t('getapi[1772]')" sortable align="right" width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="stuff_manuf_name" :title="$t('getapi[192]')" sortable width="80"></vxe-table-column>
                            <vxe-table-column field="receive_measureunit" :title="$t('getapi[1773]')" sortable align="right" width="80">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.receive_measureunit" v-if="scope.row.line_status == '到达'  || scope.row.line_status == ''"></el-input>
                                    <span v-if="scope.row.line_status != '到达'  && scope.row.line_status != ''">{{scope.row.receive_measureunit}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="check_flag" :title="$t('getapi[1308]')" sortable width="80">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.check_flag" :true-label="1" :false-label="0"
                                                 :disabled="true"></el-checkbox>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="after_in_return_qty" :title="$t('getapi[6027]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="check_type_name" :title="$t('getapi[7930]')" sortable width="80"></vxe-table-column>
                            <vxe-table-column field="fa_flag" :title="$t('getapi[11317]')" sortable width="80">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.fa_flag" :true-label="1" :false-label="0"
                                                 :disabled="true"></el-checkbox>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="remark" :title="$t('getapi[143]')" sortable width="150">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.remark"></el-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column fixed="right" align="center" :title="$t('getapi[6048]')" width="100">
                                <template slot-scope="scope">
                                    <el-button slot="reference" type="text" size="mini"
                                               @click.native.prevent="files(scope)">
                                        {{$t('getapi[3591]')}}
                                    </el-button>
                                </template>
                            </vxe-table-column>
                            <!-- <vxe-table-column fixed="right" :title="$t('basic.edit')" width="50">
                                <template slot-scope="scope">
                                    <el-popconfirm
                                            :confirmButtonText="$t('getapi[937]')"
                                            :cancelButtonText="$t('getapi[6]')"
                                            icon="el-icon-info"
                                            iconColor="red"
                                            :title="$t('getapi[637]')"
                                            @onConfirm="delline(scope)"
                                    >
                                        <el-button slot="reference" type="text" size="mini" :disabled="!btn.rowdel">{{
                                            $t('getapi[40]') }}
                                        </el-button>
                                    </el-popconfirm>
                                </template>
                            </vxe-table-column> -->
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6026]')" name="1">
                        <el-table :data="dataDetail.SerialList" style="width: 100%; margin-top:0px"
                                  :height="tableHeight - 170" :highlight-current-row="true" size="mini" border
                                  header-row-class-name="headerclass"
                                  ref="singleTable2">
                            <el-table-column show-overflow-tooltip prop="relation_line_no"
                                             :label="$t('getapi[6040]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_code"
                                             :label="$t('getapi[112]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version"
                                             :label="$t('getapi[149]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="serial_no"
                                             :label="$t('getapi[1764]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="qty" :label="$t('getapi[1628]')"
                                             align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="measureunit"
                                             :label="$t('getapi[888]')"></el-table-column>
                            <!--<el-table-column fixed="right" :label="$t('basic.edit')" width="120">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="editInfo1(scope.row)" type="primary" size="mini"
                                               :disabled="!btn.rowdel">{{ $t('getapi[40]') }}
                                    </el-button>
                                </template>
                            </el-table-column>-->
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6421]')" name="2">
                        <div class="btnnowrap">
                            <el-upload :show-file-list="false" class="upload-demo"
                                       :data="fileparmH"
                                       :action="fileurlH"
                                       :on-change="handleChangeH"
                                       :on-success="handleSuccessH"
                                       :disabled="dataDetail.Head.order_no == ''">
                                <el-button size="mini" type="primary" :disabled="dataDetail.Head.order_no == ''">{{$t('getapi[3591]')}}</el-button>
                            </el-upload>
                        </div>
                        <el-table :data="FileListsH" :height="tableHeight - 180" size="mini" style="width: 100%; margin-top:3px"
                                  header-row-class-name="headerclass"
                                  border
                                  :header-cell-style="$limits.headerClass">
                            <el-table-column show-overflow-tooltip prop="Node_Name" :label="$t('getapi[3590]')" width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Type" :label="$t('getapi[3605]')" width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Size" :label="$t('getapi[7875]')" width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Upload_Person" :label="$t('getapi[6425]')" width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Upload_Time" :label="$t('getapi[6426]')" width="150"></el-table-column>
                            <el-table-column align="center" :label="$t('getapi[6048]')" width="100">
                                <template slot-scope="scope">
                                    <el-button slot="reference" type="text" size="small" @click.native.prevent="filedelH(scope)">{{$t('getapi[40]')}}
                                    </el-button>
                                    <el-button slot="reference" type="text" size="small" @click.native.prevent="openH(scope)">{{$t('getapi[3558]')}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PurReceiveViewInfo" ref="ser" @getser="serclick"></serce>

        <ctable :isVisible="false" :title="$t('getapi[108]')" queryData="PurReceiveViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--采购订单-->
        <!--<order :isVisible="orderVisible" @getorder="getorder" ref="order"></order>-->
        <selector :isVisible="orderVisible" :isBatch=false :selectType="2" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPurOrderDataList'" @callback="getorder" ref="order"></selector>
        <!--物料-->
        <!--<recorderOM :isVisible="itemVisible" @getrecorder="getrecorder" ref="input"></recorderOM>-->
        <!-- 物料多选 -->
        <selector :isVisible="itemVisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPurReceiveDataList'" @callback="getrecorder" ref="input"></selector>
        <!-- 物料单选 -->
        <selector :isVisible="itemVisible" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPurReceiveDataList'" @callback="getrecorder" ref="inputsingle"></selector>
        <!--人员-->
        <!--<employee :isVisible="employeeVisible" @getemployee="getemployee" ref="employee"></employee>-->
        <selector :isVisible="employeeVisible" :isBatch=false :selectType="3" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getemployee" ref="employee"></selector>
        <!--检验-->
        <el-dialog v-dialogDrag :visible.sync="isShowCheck" width="40%" :close-on-click-modal="false">
            <div>
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[112]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailCheck.part_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[116]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailCheck.part_name" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[149]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailCheck.part_version" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[1762]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.wait_check_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[1767]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.disqualify_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                        <td>{{ $t('getapi[1766]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.qualify_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[1771]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.check_date" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[1770]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.check_person" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[1852]') }}</td>
                        <td>
                            <!-- <el-input v-model="dataDetailCheck.reject_reason_id" type="text" size="mini"></el-input>-->
                            <el-input
                                    :value="expReason(dataDetailCheck.reject_reason_id)"
                                    type="text"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectrejectreason(1)"></i>
                            </el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[1851]') }}</td>
                        <td colspan="3">
                            <el-input v-model="dataDetailCheck.check_remark" type="textarea" size="mini"></el-input>
                        </td>
                        <td>{{ $t('getapi[192]') }}</td>
                        <td>
                            <el-input type="textarea" size="mini" :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[1765]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.heat_no" type="text" size="mini"></el-input>
                        </td>
                        <td>{{ $t('getapi[12628]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.mrb_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowCheck = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmCheck">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <!--MRB评审-->
        <el-dialog v-dialogDrag :visible.sync="isShowMRBCheck" :width="dialogWidth" :close-on-click-modal="false">
            <div style="width:600px">
                <table>
                    <tr>
                        <td style="width:60px;min-width: 60px">{{ $t('getapi[112]') }}</td>
                        <td style="width:80px;min-width: 80px">
                            <el-input v-model="dataDetailMRBCheck.part_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:100px;min-width: 100px">{{ $t('getapi[116]') }}</td>
                        <td style="width:80px;min-width: 80px">
                            <el-input v-model="dataDetailMRBCheck.part_name" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:100px;min-width: 100px">{{ $t('getapi[149]') }}</td>
                        <td style="width:80px;min-width: 80px">
                            <el-input v-model="dataDetailMRBCheck.part_version" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[12628]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[12634]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_disqualify_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      @input="getCheckMRBNum(1)"></el-input>
                        </td>
                        <td>{{ $t('getapi[12633]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_qualify_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      @input="getCheckMRBNum(2)"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[12642]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_check_date" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[12643]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_check_person" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[12641]') }}</td>
                        <td>
                            <!-- <el-input v-model="dataDetailCheck.reject_reason_id" type="text" size="mini"></el-input>-->
                            <el-input
                                    :value="expReason(dataDetailMRBCheck.mrb_reject_reason_id)"
                                    type="text"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectrejectreason(2)"></i>
                            </el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[12644]') }}</td>
                        <td colspan="3">
                            <el-input v-model="dataDetailMRBCheck.mrb_remark" type="textarea" size="mini"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowMRBCheck = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmMRBCheck">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <!--退货-->
        <el-dialog v-dialogDrag :visible.sync="isShowReturn" width="40%" :close-on-click-modal="false" :modal-append-to-body="false">
            <div>
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[112]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailReturn.part_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[116]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailReturn.part_name" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[149]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailReturn.part_version" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[1768]') }}</td>
                        <td>
                            <el-input v-model="dataDetailReturn.ought_return_qty" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[2086]') }}</td>
                        <td>
                            <el-input v-model="dataDetailReturn.waitreturn_qty" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[2085]') }}</td>
                        <td>
                            <el-input v-model="dataDetailReturn.alreadyreturn_qty" type="text" size="mini"
                                      @input="getReturnNum()"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[2084]') }}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="dataDetailReturn.return_person"
                                    type="text"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(2)"></i>
                            </el-input>
                            </routejump>
                        </td>
                        <td>{{ $t('getapi[2083]') }}</td>
                        <td>
                            <el-input v-model="dataDetailReturn.return_time" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[1769]') }}</td>
                        <td>
                            <el-input v-model="dataDetailReturn.returned_qty" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[1851]') }}</td>
                        <td colspan="3">
                            <el-input v-model="dataDetailReturn.return_remark" type="textarea" size="mini"></el-input>
                        </td>
                        <td>{{ $t('getapi[192]') }}</td>
                        <td>
                            <el-input type="textarea" size="mini" :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowReturn = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmReturn">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <!-- 不合格原因-->
        <!--<recreason :isVisible="recreasonVisible" @getrecreason="getrecreason" ref="recreason"></recreason>-->
        <selector :isVisible="recreasonVisible" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPurReasonDataList'" @callback="getrecreason" ref="recreason"></selector>

        <el-dialog v-dialogDrag :visible.sync="isShowSerial" :title="$t('getapi[7122]')" width="40%" :close-on-click-modal="false">
            <div>
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[6040]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailSerial.relation_line_no" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[112]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailSerial.part_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[149]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailSerial.part_version" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[888]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailSerial.measureunit" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>{{ $t('getapi[895]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.item_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[7123]')}}</td>
                        <td>
                            <el-input :value="dataDetailSerial.trace_in == 0?$t('getapi[2053]'):$t('getapi[2052]')" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>{{ $t('getapi[6052]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.prefix" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>{{ $t('getapi[7124]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.digit" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>{{ $t('getapi[7125]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.start" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>{{ $t('getapi[7126]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.count" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>{{ $t('getapi[7127]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.postfix" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowSerial = false" size="mini">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmCreate(0)" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisiblefile" :title="$t('getapi[3591]')" width="50%">
            <el-upload :show-file-list="false" class="upload-demo"
                       :data="fileparm"
                       :action="fileurl"
                       :on-change="handleChange"
                       :on-success="handleSuccess">
                <el-button size="small" type="primary">{{$t('getapi[3591]')}}</el-button>
                <div slot="tip" class="el-upload__tip">{{$t('getapi[7961]')}}</div>
            </el-upload>
            <u-table :data="FileLists" border height="400" size="mini" style="width: 100%;"
                     :header-cell-style="$limits.headerClass">
                <el-table-column show-overflow-tooltip prop="Node_Name" :label="$t('getapi[3590]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Doc_Type" :label="$t('getapi[3605]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Doc_Size" :label="$t('getapi[7875]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Upload_Person" :label="$t('getapi[6425]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Upload_Time" :label="$t('getapi[6426]')" width="150"></el-table-column>
                <el-table-column fixed="right" align="center" :label="$t('getapi[6048]')">
                    <template slot-scope="scope">
                        <el-button slot="reference" type="text" size="small" @click.native.prevent="filedel(scope)">{{$t('getapi[40]')}}
                        </el-button>
                        <el-button slot="reference" type="text" size="small" @click.native.prevent="open(scope)">{{$t('getapi[3558]')}}
                        </el-button>
                    </template>
                </el-table-column>
            </u-table>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    export default {
        name: 'purreceiveview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            },
            dialogWidth(){
                return window.localStorage.getItem('lang') == 'en' ? '60%' : '40%'
            }
        },
        data() {
            return {
                tableHeader: [],
                dloading: false,
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('purreceiveview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                currentRow: null, // 当前选中行
                //isShowEdit: false, // 是否显示编辑页面
                dataDetail: {
                    Head: {},
                    LineList: [],
                    SerialList: []
                }, // 编辑页面数据详情
                oldDataDetail: '',
                order_No: '', // 当前
                recArray: [], // 计划类型数组
                isEdit: true, // 是否新增操作
                orderVisible: false, //
                itemVisible: false,

                employeeVisible: false,
                selectData: [],
                dataChecked: [],
                rowindex: -1,
                isShowCheck: false,
                dataDetailCheck: [],
                isShowMRBCheck: false,
                dataDetailMRBCheck: [],
                isShowReturn: false,
                dataDetailReturn: [],
                oldDataDetailReturn:[],
                recreasonVisible: false,
                addoredit: -1, // 1.新增2：编辑

                arrreason: [], //不合格原因数组用于解析不合格原因
                //待退货数量
                waitreturn: 0,
                //价格表中的 换算率
                huanrate: '',
                //全部检验
                allsaycheck: false,
                //取得待检数量
                waitcheckqty: '',
                //行状态
                linestaus: -1,
                btn: {
                    //全部报检
                    allcheck: false,
                    //执行报检
                    linecheck: false,
                    //取消报检
                    canclelincheck: false,
                    ///执行检验
                    confirmycheck: false,
                    ///取消检验
                    cancelecheck: false,
                    //MRB评审
                    mrbcheck: false,
                    ///执行退货
                    sayreturn: false,
                    ///检验指导书
                    instruction: false,
                    //明细行删除
                    rowdel: false,
                    //添加明细
                    add_detail: false,
                    //转正常检验
                    checktypemormal: false,
                    //关闭
                    close: false,
                    //生成序列号
                    createserial: false,
                },
                dataDetailLineNo: 1,
                isShowSerial: false, // 弹窗 序列号
                dataDetailSerial: {},
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                //上传
                isVisiblefile: false, //注意事项
                fileurl: '',
                fileparm: {
                    Code: '',
                    Data_Type: 11,
                    Login_Group:'',
                    Login_DB:'',
                },
                FileList: [],//注意事项文件
                FileLists: [], //注意事项文件
                //上传（单据）
                fileurlH: '',
                fileparmH: {
                    Code: '',
                    Data_Type: 32,
                    Login_Group:'',
                    Login_DB:'',
                },
                FileListH: [],//注意事项文件
                FileListsH: [], //注意事项文件
                rejectType: 1,//MRB评审1：执行检验2：MRB评审
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                sortRule: {property:null,order:null},
            };
        },
        created: function () {
            let that = this;
            that.recArray = Array.methods.getRecPosition();
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'purbusiness' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no, 1);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('purreceiveview', that)
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            let token = JSON.parse(that.userData).token;
            that.fileurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
            that.fileurlH = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
            let parm = {
                PageIndex: 1,
                PageSize: 1000,
                Type: 0,
                Code: '',
                Name: '',
                Param: {}
            };
            that.$http.urlpost('/Basic/Popup/GetPurReasonDataList', parm, function (res) {
                if (res.Success == 1) {
                    that.arrreason = res.DataContent.DataList;
                }
            });
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[108]"),this.$t("getapi[16]"));
            },
            tableRowClassName({row, rowIndex}) {
                if (row.Order_Status == '已检') {
                    return 'red';
                }
            },
            tableRowClassNameDetail({ row, rowIndex }) {
                row.index = rowIndex;
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('PurReceiveViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(!this.$limits.menuvisible("plv2", 212, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 211, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 212, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                    }
                    if (that.$limits.authority('plv2', 212, 1) == 2) {
                        if (that.$limits.authority('plv3', 212,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 212,1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 212, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if (that.dataDetail.Head.order_status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                }

                                if(that.dataDetail.Head.order_status == 0){
                                    that.$refs.SetBtn.SetOneBtnEnable('del',true);
                                }
                                else{
                                    that.$refs.SetBtn.SetOneBtnEnable('del',false);
                                }

                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }

                if(that.dataDetail.Head.order_status ==3){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false)
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                var rowNum = 0;
                var ISAllCheck = false;
                //全部报检
                that.btn.allcheck = false;
                //执行报检
                that.btn.linecheck = false;
                //取消报检
                that.btn.canclelincheck = false;
                //执行检验
                that.btn.confirmycheck = false;
                //取消检验
                that.btn.cancelecheck = false;
                //MRB评审
                that.btn.mrbcheck = false;
                //执行退货
                that.btn.sayreturn = false;
                //检验指导书
                that.btn.instruction = false;
                //转正常检验
                that.btn.checktypemormal = false;
                //行删除
                that.btn.rowdel = false;
                that.btn.add_detail = false;
                //关闭订单 
                that.btn.close=false;
                // 生成序列号
                that.btn.createserial = false
                
                if (that.$limits.authority('plv4', 35, 1) == 1){
                    if(that.dataDetail.Head.order_status == 2){
                         that.btn.close=true;
                    }
                    else{
                         that.btn.close=false;
                    }
                }
                else{
                    that.btn.close=false;
                }

                if(that.dataDetail.LineList.length<=0){
                    that.btn.close=false;
                }

                that.allsaycheck = true;
                if(that.dataDetail.Head.order_status == 0){
                    that.btn.add_detail = true;
                }

                for (let i = 0; i < that.dataDetail.LineList.length; i++) {
                    if (that.dataDetail.LineList[i].line_status == 0 || that.dataDetail.LineList[i].line_status == '到达') {
                        ISAllCheck = true;
                    }
                }
                
                if (ISAllCheck == false) {
                    that.allsaycheck = false;
                }
                if (that.allsaycheck) {
                    that.btn.allcheck = true; //全部报检
                } else {
                    that.btn.allcheck = false; //全部报检
                }
                //转正常检验
                if (that.selectData.length > 0) {
                    // console.log('测试全部报检:' + that.allsaycheck);
                    rowNum = that.selectData.length - 1;

                    var EnableCanIn = false;
                    var EnableCanOut = false;
                    if (!that.$limits.fnIsEmpty(that.selectData[rowNum].part_code)) {
                        // console.log("供应商代码:"+that.dataDetail.Head.vender_code);
                        // console.log("唯一号:"+that.selectData[0].relation_po_line_id);
                        that.gethuanrate(that.dataDetail.Head.vender_code, that.selectData[rowNum].relation_po_line_id);
                        //获取明细行状态
                        // that.getPictureStatus(that.dataDetail.Head.order_no, that.selectData[0].row_number);
                        //将明细行状态赋值给linestaus字段
                        //0到达 1待检 2已检 3关闭，默认0
                        // console.log('选中行数据:' + JSON.stringify(that.selectData[0]));
                        that.linestaus = that.selectData[rowNum].line_status;
                        if (!that.$limits.fnIsEmpty(that.huanrate)) {
                            // console.log('单据号:' + that.dataDetail.Head.order_no);
                        }
                        if (that.linestaus == 0 || that.linestaus == 1 || that.linestaus == '到达' || that.linestaus == '待检') {
                            // that.getWaitCheckQuantity(that.dataDetail.Head.order_no, that.selectData[0].row_number);
                            that.waitcheckqty = that.selectData[rowNum].wait_check_qty;
                        }
                        console.log("全部报检1"+that.btn.allcheck);
                                console.log("全部报检2:"+parseFloat(that.waitcheckqty));
                        // console.log('测试待检数量:' + that.waitcheckqty);
                        //到达
                        if (that.linestaus == 0 || that.linestaus == '到达') {
                            if(that.selectData.length == 1){
                                that.btn.checktypemormal = true;
                            }
                            // console.log('到达状态:' + that.btn.rowdel);
                            if (that.$limits.fnIsEmpty(that.waitcheckqty)) {
                                that.btn.allcheck = true; //全部报检
                                that.btn.rowdel = true; //删除行
                                that.btn.linecheck = true; //执行报检
                            } else {
                                if (parseFloat(that.waitcheckqty) >= 0) {
                                    that.btn.allcheck = true; //全部报检
                                    that.btn.rowdel = true; //删除行
                                    that.btn.linecheck = true; //执行报检
                                } else {
                                    that.btn.allcheck = false; //全部报检
                                    that.btn.rowdel = false; //删除行
                                    that.btn.linecheck = false; //执行报检
                                }
                            }
                        }
                        //待检
                        if (that.linestaus == 1 || that.linestaus == '待检') {
                            // console.log('待检状态:' + that.btn.rowdel);
                            that.btn.allcheck = false; //全部报检
                            if (that.$limits.fnIsEmpty(that.waitcheckqty)) {
                                that.btn.canclelincheck = true; //取消报检
                            } else {
                                if (parseFloat(that.waitcheckqty) >= 0) {
                                    that.btn.canclelincheck = true; //全部报检
                                    that.btn.confirmycheck = true; //执行检验
                                } else {
                                    that.btn.canclelincheck = false; //全部报检
                                    that.btn.confirmycheck = false; //执行检验
                                }
                            }
                            that.btn.instruction = true; //检验指导书
                        }
                        //入库数量不等于0
                        //已检
                        if (that.linestaus == 2 || that.linestaus == '已检') {
                            that.btn.allcheck = false; //全部报检
                            if (that.$limits.fnIsEmpty(that.selectData[rowNum].receive_qty)) {
                                EnableCanIn = true; //取消检验
                            } else {
                                if (
                                    parseFloat(that.selectData[rowNum].receive_qty) <
                                    parseFloat(that.selectData[rowNum].actual_qty) / parseFloat(that.huanrate) - parseFloat(that.selectData[rowNum].disqualify_qty)
                                ) {
                                    EnableCanIn = true; //取消检验
                                } else {
                                    EnableCanIn = false; //取消检验
                                }
                            }
                            if (that.$limits.fnIsEmpty(that.selectData[rowNum].returned_qty)) {
                                EnableCanOut = true; //取消检验
                            } else {
                                EnableCanOut = false; //取消检验
                            }

                            if (EnableCanIn == true && EnableCanOut == true) {
                                that.btn.cancelecheck = true; //取消检验
                                //生成序列号
                                if(that.selectData.length == 1 && that.selectData[0].issequencetrace == 1 && that.selectData[0].receive_qty == 0){
                                    that.btn.createserial = true
                                }
                                // if (parseFloat(that.selectData[0].receive_qty) == 0) {
                                // 	// if (bool.Parse(dgvPurSheet.SelectedRows[0].Cells['isSequenceTrace'].Value.ToString())) {
                                // 	// 	cmnuReceive.Items['mSerial'].Enabled = true; //生成序列号
                                // 	// }
                                // }
                            }
                            // that.getWaitReturnQuantity(that.dataDetail.Head.order_no, that.selectData[0].row_number);

                            that.waitreturn = parseFloat(that.selectData[rowNum].ought_return_qty) - parseFloat(that.selectData[rowNum].returned_qty);
                            if (that.waitreturn != 0) {
                                that.btn.sayreturn = true; //执行退货
                            }
                        }
                        //MRB评审
                        if (that.linestaus == 4 || that.linestaus == 'MRB评审') {
                            if (that.selectData.length == 1 && parseFloat(that.selectData[0].mrb_qty) >= 0) {
                                if (that.$limits.authority('plv4', 213, 1) == 1){
                                    that.btn.mrbcheck = true;
                                } else {
                                    that.btn.mrbcheck = false;
                                }
                            }
                        }
                        if (that.btn.rowdel == true) {
                            if (that.$limits.authority('plv4', 140, 1) == 1) {
                                //删除行 可用
                                that.btn.rowdel = true; //删除行
                            } else {
                                that.btn.rowdel = false;
                            }
                        }
                        if (that.btn.linecheck == true) {
                            if (that.$limits.authority('plv4', 141, 1) == 1) {
                                //执行报检 可用
                                that.btn.linecheck = true; //执行报检
                            } else {
                                that.btn.linecheck = false;
                            }
                        }
                        if (that.btn.canclelincheck == true) {
                            if (that.$limits.authority('plv4', 142, 1) == 1) {
                                //取消报检 可用
                                that.btn.canclelincheck = true; //取消报检
                            } else {
                                that.btn.canclelincheck = false;
                            }
                        }
                        if (that.btn.confirmycheck == true) {
                            if (that.$limits.authority('plv4', 143, 1) == 1) {
                                //执行检验 可用
                                that.btn.confirmycheck = true; //执行检验
                            } else {
                                that.btn.confirmycheck = false;
                            }
                        }
                        if (that.btn.cancelecheck == true) {
                            if (that.$limits.authority('plv4', 144, 1) == 1) {
                                //取消检验 可用
                                that.btn.cancelecheck = true; //取消检验
                            } else {
                                that.btn.cancelecheck = false;
                            }
                        }
                        if (that.btn.sayreturn == true) {
                            if (that.$limits.authority('plv4', 262, 1) == 1) {
                                //执行退货 可用
                                that.btn.sayreturn = true; //执行退货
                            } else {
                                that.btn.sayreturn = false;
                            }
                        }
                        if (that.btn.checktypemormal == true) {
                            if (that.$limits.authority('plv4', 185, 1) == 1) {
                                that.btn.checktypemormal = true;
                            } else {
                                that.btn.checktypemormal = false;
                            }
                        }
                    }
                }
                //权限控制
                if (that.btn.allcheck == true) {
                    if (that.$limits.authority('plv4', 139, 1) == 1) {
                        //全部报检 可用
                        that.btn.allcheck = true; //全部报检
                    } else {
                        that.btn.allcheck = false;
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            keyup(ev, row) {
                let that = this;
                that.editInfo(row);
            },
            keydown(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet[index - 1];
                    that.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet[index + 1];
                    that.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.dataSet.findIndex(item => item.order_No === val.order_No);
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('purreceiveview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurReceiveViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            //获取待退货数量
            getWaitReturnQuantity(order_no, rownum) {
                let that = this;
                let token = JSON.parse(that.userData).token;
                let data = {
                    order_no: order_no,
                    row_number: rownum
                };
                that.$http.urlpost('/Pur/Receive/GetWaitReturnQuantity', data, function (res) {
                    if (res.Success == 1) {
                        that.waitreturn = res.DataContent.waitreturn;
                        return 1;
                    }
                });
            },
            //获取换算率
            gethuanrate(vendercode, order_no) {
                let that = this;
                let token = JSON.parse(that.userData).token;
                let data = {
                    order_no: order_no,
                    vendercode: vendercode
                };
                that.$http.urlpost('/Pur/Receive/GetHuanSuanRate', data, function (res) {
                    if (res.Success == 1) {
                        that.huanrate = res.DataContent.huanrate;
                        return true;
                    }
                });
            },
            // 判断是否需要全部报检
            getAllStatus() {
                let that = this;
                that.allsaycheck = false;
                // if (that.selectData.length > 0) {
                var ISAllCheck = false;
                console.log("明细行数:" + that.dataDetail.LineList.length);
                for (let i = 0; i < that.dataDetail.LineList.length; i++) {
                    if (that.dataDetail.LineList[i].line_status != 0 || that.dataDetail.LineList[i].line_status != '到达') {
                        console.log("明细行数状态:" + that.dataDetail.LineList[i].line_status);
                        ISAllCheck = true;
                    }
                }
                if (ISAllCheck == false) {
                    that.allsaycheck = false;
                }
                // }

                // let token = JSON.parse(that.userData).token;
                // let data = {
                // 	order_no: order_no
                // };
                // that.$http.urlpost('/Pur/Receive/GetAllStatus', data, function(res) {
                // 	if (res.Success == 1) {
                // 		that.allsaycheck = res.DataContent.allcheck;
                // 		return true;
                // 	} else {
                // 		that.$message.error(res.Msg);
                // 		return false;
                // 	}
                // });
            },            
            closebill() {
                let that = this;
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    modify_time: that.dataDetail.Head.modify_time,
                    LineList:that.dataDetail.LineList,
                    LangType: that.$processdata.getLang(),
                };
                that.btn.close = false
                that.$http.urlpost('/Pur/Receive/ColsePurReceive', parm, function (res) {
                    that.btn.close = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(res.UniqueNum);
                    }
                });
            },
            // 获取明细行状态
            getPictureStatus(order_no, rownum) {
                let that = this;
                let token = JSON.parse(that.userData).token;
                let data = {
                    order_no: order_no,
                    row_number: rownum
                };
                that.$http.urlpost('/Pur/Receive/GetPictureStatus', data, function (res) {
                    if (res.Success == 1) {
                        that.linestaus = res.DataContent.status;
                        return true;
                    }
                });
            },
            //取得待检数量
            getWaitCheckQuantity(order_no, rownum) {
                let that = this;
                let token = JSON.parse(that.userData).token;
                let data = {
                    order_no: order_no,
                    row_number: rownum
                };
                that.$http.urlpost('/Pur/Receive/GetWaitCheckQuantity', data, function (res) {
                    if (res.Success == 1) {
                        that.waitcheckqty = res.DataContent.waitcheck;
                        return true;
                    }
                });
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Receive/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.$nextTick(function(){
                            that.$processdata.initForm(0)
                        });
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.order_No == row.order_No){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail;
                    for (let i = 0; i < datacopy.LineList.length; i++) {
                        delete datacopy.LineList[i]['index'];
                        delete datacopy.LineList[i]['_XID'];
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.order_No = row.order_No;
                                that.getDetail(row.order_No);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.order_No = row.order_No;
                        that.getDetail(row.order_No);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(order_No) {
                let that = this;
                that.dloading = true;
                that.addoredit = 2;
                that.selectData = [];
                that.dataChecked = [];
                let parm = {
                    Code: order_No
                };
                that.FileList = [];
                that.FileLists = [];
                that.FileListH = [];
                that.FileListsH = [];
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pur/Receive/GetPurReceiveInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.selectData = [];
                        that.dataChecked = [];
                        that.FileList = res.DataContent.Attrs;
                        that.FileList.forEach(item => {
                            if (item.Code == that.fileparm.Code) {
                                that.FileLists.push(item);
                            }
                        })
                        that.FileListH = res.DataContent.fileLists;
                        if(that.FileListH){
                            that.FileListH.forEach(item => {
                                if (item.Code == that.dataDetail.Head.order_no) {
                                    that.FileListsH.push(item);
                                }
                            })
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority();
                        that.$nextTick(function(){
                            that.$processdata.initForm(0)
                            that.$processdata.initFormRight(0)
                        });
                    }
                    that.dloading = false;
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.LineList.length; i++) {
                    delete datacopy.LineList[i]['index'];
                    delete datacopy.LineList[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.addoredit = 1;
                that.order_No = ''
                that.dataDetail = {
                    Head: {
                        relation_po_code: '',
                        order_no: '',
                        delive_order_no: '',
                        create_time: datetime,
                        create_person: that.user,
                        modify_person: that.user,
                        modify_time: datetime,
                        receive_person: '',
                        receive_time: datetime,
                        order_status: 0, // 0到达 1待检 2已检 3关闭
                        remark: '',
                        receive_position: '',
                        vender_code: '',
                        vender_name: ''
                    },
                    LineList: [],
                    SerialList: []
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if (that.addoredit != 1) {
                    that.getDetail(that.order_No)
                } else {
                    that.add()
                }*/
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.LineList.length; i++) {
                    delete datacopy.LineList[i]['index'];
                    delete datacopy.LineList[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit != 1){
                                that.getView();
                                that.getDetail(that.order_No)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit != 1){
                        that.getView();
                        that.getDetail(that.order_No)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pur/Receive/ExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PurReceiveViewInfo",
                    fromname: that.$t('getapi[108]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let arr = []
                for(let i = 0;i<that.dataDetail.LineList.length;i++){
                    arr = [...arr, that.dataDetail.LineList[i].row_number]
                }
                if(that.$limits.isRepeat(arr)){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
                    let parm = that.dataDetail;
                    parm.LangType =that.$processdata.getLang()
                    that.$http.urlpost('/Pur/Receive/SaveData', parm, function (res) {
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            let parm = res.UniqueNum;
                            that.order_No = parm;
                            that.getDetail(parm);
                        }
                    });
                } else {
                    that.$message.warning(that.$t('getapi[2124]'));//'行号不能重复！'
                }
            },
            //获取采购订单
            selectOrder() {
                let that = this;
                that.orderVisible = true;
                that.$refs.order.clearInput(this.orderVisible, false, 2);
            },
            // 获取订单信息
            getorder(data) {
                let that = this;
                let datetime = Common.methods.getDatetime()
                let date = Common.methods.getDate()
                that.dataDetail.Head.relation_po_code = data.po_code;
                that.dataDetail.Head.vender_code = data.vender_code;
                that.dataDetail.Head.vender_name = data.vender_name;
                that.dataDetail.Head.receive_time = datetime;
                that.dataDetail.Head.create_time = date;
                that.dataDetail.Head.create_person = that.user;
                that.dataDetail = {...that.dataDetail};
            },
            // 新增物料
            showAddBom(row) {
                let that = this;
                if(that.dataDetail.Head.relation_po_code == '' || that.dataDetail.Head.relation_po_code == null){
                    that.$message.warning(that.$t('getapi[8743]'));//'订单号不能为空'
                    return
                }
                that.itemVisible = true;
                if (row == '') {
                    that.oneormore = 1;
                    let param = {
                        po_code: that.dataDetail.Head.relation_po_code
                    }
                    that.$refs.input.clearInput(that.itemVisible, param);
                } else {
                    that.oneormore = 2;
                    this.rowindex = row.$rowIndex;
                    let param = {
                        po_code: that.dataDetail.Head.relation_po_code
                    }
                    that.$refs.inputsingle.clearInput(that.itemVisible, param);
                }
            },
            // 获取物料信息
            getrecorder(data) {
                let that = this;
                console.log(data);
                if (that.oneormore == 1) {
                    let arr = data.filter(item => {
                        return that.dataDetail.LineList.every(item2 => {
                            return item.part_code != item2.part_code;
                        });
                    });
                    data = arr;
                    that.dataDetailLineNo = 1
                    for (let i = 0; i < that.dataDetail.LineList.length; i++) {
                        if (that.dataDetail.LineList[i].row_number >= that.dataDetailLineNo) {
                            that.dataDetailLineNo = that.dataDetail.LineList[i].row_number + 1
                        }
                    }
                    for (let i = 0; i < data.length; i++) {
                        that.dataDetail.LineList = [
                            ...that.dataDetail.LineList,
                            {
                                row_number: that.dataDetailLineNo++,
                                part_code: data[i].part_code,
                                part_name: data[i].part_name,
                                part_version: data[i].part_version,
                                part_stuff: data[i].part_stuff,
                                order_qty: data[i].po_qty+data[i].over_qty,
                                receive_qty: '',
                                specification: data[i].specification,
                                model: data[i].model,
                                stuff_manuf_name: data[i].stuff_manuf_name,
                                check_flag: data[i].check_flag == true?1:0,
                                exclusively_id: '',
                                pur_measureunit: data[i].pur_measureunit,
                                isdel: 0,
                                isadd: 1,
                                relation_order_no: '',
                                relation_po_line_id: data[i].exclusively_id,
                                cargoposition_code: '',
                                actual_qty: 0,
                                wait_check_qty: 0,
                                disqualify_qty: 0,
                                reject_reason_id: 0,
                                qualify_qty: 0,
                                ought_return_qty: 0,
                                returned_qty: 0,
                                receive_measureunit: '',
                                check_date: '',
                                check_person: '',
                                return_time: '',
                                return_person: '',
                                return_remark: '',
                                batch_no: '*',
                                sequence_no: '*',
                                line_status: '',
                                check_remark: '',
                                remark: data[i].remark,
                                pqc_qty: 0,
                                process_reject_reason_id: 0,
                                assist_receive_qty: 0,
                                assist_measureunit: '',
                                concedeqty: 0,
                                after_in_return_qty: 0,
                                heat_no: '',
                                issequencetrace: 0,
                                pur_row_number: '',
                                sums: data[i].ramount,
                                freevalue: data[i].freevalue,
                                fa_flag:data[i].fa_flag
                            }
                        ];
                    }
                } else {
                    for(let i = 0;i<that.dataDetail.LineList.length;i++){
                        if(data.part_code == that.dataDetail.LineList[i].part_code){
                            return
                        }
                    }
                    that.dataDetail.LineList[that.rowindex].exclusively_id = '';
                    that.dataDetail.LineList[that.rowindex].part_code = data.part_code;
                    that.dataDetail.LineList[that.rowindex].part_name = data.part_name;
                    that.dataDetail.LineList[that.rowindex].part_version = data.part_version;
                    that.dataDetail.LineList[that.rowindex].part_stuff = data.part_stuff;
                    that.dataDetail.LineList[that.rowindex].order_qty = data.po_qty+data.over_qty;
                    that.dataDetail.LineList[that.rowindex].receive_qty = '';
                    that.dataDetail.LineList[that.rowindex].specification = data.specification;
                    that.dataDetail.LineList[that.rowindex].model = data.model;
                    that.dataDetail.LineList[that.rowindex].stuff_manuf_name = data.stuff_manuf_name;
                    that.dataDetail.LineList[that.rowindex].check_flag = data.check_flag == true?1:0;
                    that.dataDetail.LineList[that.rowindex].pur_measureunit = data.pur_measureunit;
                    that.dataDetail.LineList[that.rowindex].isdel = 0;
                    that.dataDetail.LineList[that.rowindex].isadd = 0;
                    that.dataDetail.LineList[that.rowindex].relation_order_no = '';
                    that.dataDetail.LineList[that.rowindex].relation_po_line_id = data.exclusively_id;
                    that.dataDetail.LineList[that.rowindex].cargoposition_code = '';
                    that.dataDetail.LineList[that.rowindex].actual_qty = 0;
                    that.dataDetail.LineList[that.rowindex].wait_check_qty = 0;
                    that.dataDetail.LineList[that.rowindex].disqualify_qty = 0;
                    that.dataDetail.LineList[that.rowindex].reject_reason_id = 0;
                    that.dataDetail.LineList[that.rowindex].qualify_qty = 0;
                    that.dataDetail.LineList[that.rowindex].ought_return_qty = 0;
                    that.dataDetail.LineList[that.rowindex].returned_qty = 0;
                    that.dataDetail.LineList[that.rowindex].receive_measureunit = '';
                    that.dataDetail.LineList[that.rowindex].check_date = '';
                    that.dataDetail.LineList[that.rowindex].check_person = '';
                    that.dataDetail.LineList[that.rowindex].return_time = '';
                    that.dataDetail.LineList[that.rowindex].return_person = '';
                    that.dataDetail.LineList[that.rowindex].return_remark = '';
                    that.dataDetail.LineList[that.rowindex].batch_no = '*';
                    that.dataDetail.LineList[that.rowindex].sequence_no = '*';
                    that.dataDetail.LineList[that.rowindex].line_status = '';
                    that.dataDetail.LineList[that.rowindex].check_remark = '';
                    that.dataDetail.LineList[that.rowindex].remark = data.remark;
                    that.dataDetail.LineList[that.rowindex].pqc_qty = 0;
                    that.dataDetail.LineList[that.rowindex].process_reject_reason_id = 0;
                    that.dataDetail.LineList[that.rowindex].assist_receive_qty = 0;
                    that.dataDetail.LineList[that.rowindex].assist_measureunit = '';
                    that.dataDetail.LineList[that.rowindex].concedeqty = 0;
                    that.dataDetail.LineList[that.rowindex].after_in_return_qty = 0;
                    that.dataDetail.LineList[that.rowindex].heat_no = '';
                    that.dataDetail.LineList[that.rowindex].issequencetrace = 0;
                    that.dataDetail.LineList[that.rowindex].pur_row_number = '';
                    that.dataDetail.LineList[that.rowindex].sums = data.ramount;
                    that.dataDetail.LineList[that.rowindex].freevalue = data.freevalue;
                    that.dataDetail.LineList[that.rowindex].fa_flag = data.fa_flag;
                }
            },
            selectemployee(type) {
                let that = this;
                that.employeeVisible = true;
                that.employeeType = type;
                that.$refs.employee.clearInput(this.employeeVisible);
            },
            getemployee(data) {
                let that = this;
                if (that.employeeType == 1) {
                    that.dataDetail.Head.receive_person = data.name;
                } else if (that.employeeType == 2) {
                    that.dataDetailReturn.return_person = data.name;
                }
            },
            expstatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1622]')//'到达';
                } else if (val == 1) {
                    return that.$t('getapi[1803]')//'待检';
                } else if (val == 2) {
                    return that.$t('getapi[1749]')//'已检';
                } else if (val == 3) {
                    return that.$t('getapi[441]')//'关闭';
                } else if (val == 4) {
                    return that.$t('getapi[12627]')//'MRB评审';
                } else {
                    return '';
                }
            },
            handleSelectionChange({ records }) {
                let that = this;
                that.selectData = [];
                that.dataChecked = [];
                that.selectData = records
                for (let i = 0; i < records.length; i++) {
                    that.dataChecked.push(records[i].exclusively_id);
                }
                that.btnauthority();
            },
            allCheck() {
                let that = this;
                let arr = [];
                for (let i = 0; i < that.dataDetail.LineList.length; i++) {
                    arr = [
                        ...arr,
                        {
                            row_number: that.dataDetail.LineList[i].row_number,
                            actual_qty: that.dataDetail.LineList[i].actual_qty,
                            check_flag: that.dataDetail.LineList[i].check_flag,
                            check_type: that.dataDetail.LineList[i].check_type,
                            fa_flag:that.dataDetail.LineList[i].fa_flag,
                        }
                    ];
                }
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    modify_time: that.dataDetail.Head.modify_time,
                    Lines: arr
                };
                that.btn.allcheck = false
                that.$http.urlpost('/Pur/Receive/PurReceiveAllSayCheck', parm, function (res) {
                    that.btn.allcheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            batchDel() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        for (let i = 0; i < that.dataDetail.LineList.length; i++) {
                            for (let j = 0; j < that.dataChecked.length; j++) {
                                if (that.dataDetail.LineList[i].exclusively_id == that.dataChecked[j]) {
                                    that.dataDetail.LineList[i].isdel = 1;
                                }
                            }
                        }
                        let arr = that.dataDetail.LineList.filter(item => {
                            return item.isdel != 1 || item.isadd != 1;
                        });
                        that.dataDetail.LineList = arr;
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            delline() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning('只支持单行删除,请重新勾选');
                    return;
                }
                that.dataDetail.LineList.splice(that.selectData[0].index, 1);
                if (that.selectData[0].exclusively_id != '') {
                    let parm = {
                        order_no: that.dataDetail.Head.order_no,
                        modify_time: that.dataDetail.Head.modify_time,
                        row_number: that.selectData[0].row_number
                    };
                    that.$http.urlpost('/Pur/Receive/PurReceiveDelLine', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getDetail(that.order_No);
                        }
                    });
                }
            },
            lineCheck() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning('不支持多行执行报检,请重新勾选');
                    return;
                }
                let parm = {
                    actual_qty: that.selectData[0].actual_qty,
                    check_flag: that.selectData[0].check_flag,
                    fa_flag: that.selectData[0].fa_flag,
                    check_type: that.selectData[0].check_type,
                    order_no: that.dataDetail.Head.order_no,
                    row_number: that.selectData[0].row_number
                };
                that.btn.linecheck = false
                that.$http.urlpost('/Pur/Receive/PurReceiveLineCheck', parm, function (res) {
                    that.btn.linecheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            cLineCheck() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning('不支持多行取消报检,请重新勾选');
                    return;
                }

                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    row_number: that.selectData[0].row_number
                };
                that.btn.canclelincheck = false
                that.$http.urlpost('/Pur/Receive/PurReceiveCancleLineCheck', parm, function (res) {
                    that.btn.canclelincheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            check() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[9374]'));
                    return;
                }
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    vender_code: that.dataDetail.Head.vender_code,
                    row_number: that.selectData[0].row_number,
                    part_code: that.selectData[0].part_code,
                    part_version: that.selectData[0].part_version,
                    fa_flag:that.selectData[0].fa_flag,
                    LangType: that.$processdata.getLang(),
                };
                that.btn.confirmycheck = false
                that.$http.urlpost('/Pur/Receive/PurReceiveVerifyCheck', parm, function (res) {
                    that.btn.confirmycheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.showCheckDialog(that.selectData[0]);
                    } else if (res.Success == 2) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.showCheckDialog(that.selectData[0]);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            showCheckDialog(data) {
                let that = this;
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    row_number: data.row_number
                };
                that.$http.urlpost('/Pur/Receive/GetPurReceiveCheckInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowCheck = true;
                        that.dataDetailCheck = res.DataContent;
                        that.dataDetailCheck.check_person = that.user;
                        that.dataDetailCheck.heat_no = '*';
                        that.dataDetailCheck.qualify_qty = that.dataDetailCheck.wait_check_qty; // 合格数量默认待检数量
                        that.getDetail(that.order_No);
                    }
                });
            },
            confirmCheck() {
                let that = this;
                if(that.dataDetailCheck.wait_check_qty != (parseFloat(that.dataDetailCheck.disqualify_qty)+parseFloat(that.dataDetailCheck.qualify_qty)+parseFloat(that.dataDetailCheck.mrb_qty))){
                    that.$message.warning(that.$t('getapi[12629]'))
                    return
                }
                let date = Common.methods.getDatetime();
                that.dataDetailCheck.ought_return_qty = parseFloat(that.dataDetailCheck.disqualify_qty);
                that.dataDetailCheck.disqualify_qty = parseFloat(that.dataDetailCheck.disqualify_qty);
                that.dataDetailCheck.qualify_qty = parseFloat(that.dataDetailCheck.qualify_qty);
                that.dataDetailCheck.check_date = date;
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    vender_code: that.dataDetail.Head.vender_code,
                    receive_time: that.dataDetail.Head.receive_time,
                    Line: that.dataDetailCheck,
                    LangType: that.$processdata.getLang(),
                };
                that.$http.urlpost('/Pur/Receive/PurReceiveConfirmCheck', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowCheck = false;
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            cCheck() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning('不支持多行取消检验,请重新勾选');
                    return;
                }
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    row_number: that.selectData[0].row_number,
                    check_flag: that.selectData[0].check_flag
                };
                that.btn.cancelecheck = false
                that.$http.urlpost('/Pur/Receive/PurReceiveCancleCheck', parm, function (res) {
                    that.btn.cancelecheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            sayReturn() {
                let that = this;
                if(!that.btn.sayreturn){
                    return false
                }
                if (that.selectData.length > 1) {
                    that.$message.warning('不支持多行执行退货,请重新勾选');
                    return;
                }
                that.isShowReturn = true;
                let parm = {
                    relation_order_no: that.selectData[0].relation_order_no,
                    row_number: that.selectData[0].row_number
                };
                that.btn.sayreturn = false
                that.$http.urlpost('/Pur/Receive/GetReturnByOrderRow', parm, function (res) {
                    that.btn.sayreturn = true
                    if (res.Success == 1) {
                        /*that.$message.success(Common.SuccessMsg);*/
                        that.dataDetailReturn = res.DataContent.Line;
                        that.oldDataDetailReturn = JSON.stringify(that.dataDetailReturn)
                    }
                });
            },
            confirmReturn() {
                let that = this;
                let parm = {
                    relation_order_no: that.dataDetailReturn.relation_order_no,
                    row_number: that.dataDetailReturn.row_number,
                    relation_po_line_id: that.dataDetailReturn.relation_po_line_id,
                    part_code: that.dataDetailReturn.part_code,
                    part_name: that.dataDetailReturn.part_name,
                    part_version: that.dataDetailReturn.part_version,
                    qualify_qty: that.dataDetailReturn.qualify_qty,
                    ought_return_qty: that.dataDetailReturn.ought_return_qty,
                    returned_qty: that.dataDetailReturn.returned_qty,
                    waitreturn_qty: that.dataDetailReturn.waitreturn_qty,
                    alreadyreturn_qty: that.dataDetailReturn.alreadyreturn_qty,
                    return_time: that.dataDetailReturn.return_time,
                    return_person: that.dataDetailReturn.return_person,
                    return_remark: that.dataDetailReturn.return_remark
                };
                that.$http.urlpost('/Pur/Receive/PurReceiveSayReturn', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowReturn = false;
                        that.getDetail(that.order_No);
                    }
                });
            },
            mrbCheck(data) {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[4229]'));
                    return;
                }
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    row_number: that.selectData[0].row_number
                };
                that.$http.urlpost('/Pur/Receive/GetPurReceiveCheckInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowMRBCheck = true;
                        that.dataDetailMRBCheck = res.DataContent;
                        that.dataDetailMRBCheck.mrb_check_person = that.user;
                        that.dataDetailMRBCheck.mrb_qualify_qty = that.dataDetailMRBCheck.mrb_qty; // 合格数量默认待检数量
                    }
                });
            },
            confirmMRBCheck() {
                let that = this;
                let date = Common.methods.getDatetime();
                that.dataDetailMRBCheck.ought_return_qty = parseFloat(that.dataDetailMRBCheck.mrb_disqualify_qty);
                that.dataDetailMRBCheck.mrb_disqualify_qty = parseFloat(that.dataDetailMRBCheck.mrb_disqualify_qty);
                that.dataDetailMRBCheck.mrb_qualify_qty = parseFloat(that.dataDetailMRBCheck.mrb_qualify_qty);
                that.dataDetailMRBCheck.check_date = date;
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    vender_code: that.dataDetail.Head.vender_code,
                    receive_time: that.dataDetail.Head.receive_time,
                    Line: that.dataDetailMRBCheck,
                    LangType: that.$processdata.getLang(),
                };
                that.$http.urlpost('/Pur/Receive/PurReceiveMrbConfirm', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowMRBCheck = false;
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            instruction() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(this.$t('getapi[9388]'));//'不支持多行检验指导书,请重新勾选'
                    return;
                }
                let parm = {
                    part_code: that.selectData[0].part_code,
                    LangType: that.$processdata.getLang(),
                };
                that.btn.instruction = false
                that.$http.urlpost('/Pur/Receive/PurReceiveInstruction', parm, function (res) {
                    that.btn.instruction = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            // 转正常检验
            checkTypeNormal(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    row_number: that.selectData[0].row_number
                }
                that.$http.urlpost('/Pur/Receive/PurUpdateCheckTypeNormal', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            selectrejectreason(type) {
                let that = this;
                that.recreasonVisible = true;
                that.rejectType = type
                let param = {
                    po_code: ''
                }
                that.$refs.recreason.clearInput(this.recreasonVisible, param);
            },
            getrecreason(data) {
                let that = this;
                console.log(data);
                if(that.rejectType == 1){
                    that.dataDetailCheck.reject_reason_id = data.num;
                } else  if(that.rejectType == 2){
                    that.dataDetailMRBCheck.mrb_reject_reason_id = data.num;
                }
            },
            expReason(val) {
                let that = this;
                let res = '';
                for (let i = 0; i < that.arrreason.length; i++) {
                    if (that.arrreason[i].num == val) {
                        res = that.arrreason[i].description;
                        break;
                    }
                }
                return res;
            },
            getCheckMRBNum(type){
                let that = this
                if (type == 1) {
                    that.dataDetailMRBCheck.mrb_qualify_qty = that.dataDetailMRBCheck.mrb_qty - that.dataDetailMRBCheck.mrb_disqualify_qty
                } else if (type == 2) {
                    that.dataDetailMRBCheck.mrb_disqualify_qty = that.dataDetailMRBCheck.mrb_qty - that.dataDetailMRBCheck.mrb_qualify_qty
                }
            },
            // 执行退货获取合格和不合格数量
            getReturnNum() {
                let that = this
                if (that.dataDetailCheck.alreadyreturn_qty > that.dataDetailReturn.ought_return_qty) {
                    return
                }
            },
            //单据删除
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            modify_time: that.dataDetail.Head.modify_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pur/Receive/DelPurReceive', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //生成序列号
            createSerial(){
                let that = this
                that.isShowSerial = true
                that.dataDetailSerial = {
                    relation_line_no: that.selectData[0].row_number,
                    part_code: that.selectData[0].part_code,
                    part_version: that.selectData[0].part_version,
                    measureunit: that.selectData[0].pur_measureunit,
                    prefix: '',
                    digit: '',
                    start: 1,
                    count: that.selectData[0].actual_qty,
                    postfix: '',
                    item_code: '',
                    trace_in: ''
                }
            },
            confirmCreate(val){
                let that = this
                let parm = {
                    relation_order_no: that.selectData[0].relation_order_no,
                    issequencetrace: that.selectData[0].issequencetrace,
                    iscontinue: val,
                    Head: that.dataDetailSerial,
                    SerialList: that.dataDetail.SerialList,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Pur/Receive/PurReceiveCreateSerial', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.dataDetail.SerialList = res.DataContent.SerialList
                        that.isShowSerial = false
                    } else if(res.Success > 1){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmCreate(res.Success);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            // 打印
            print(){
                let that = this
                if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){
                    return;
                }
                that.loading = true;
                let templatename = '28送货单GQ.xlsx'
                let parm = {
                    po_no: that.dataDetail.Head.order_no,
                    TemplateName: templatename
                };
                that.$http.urlpost('/Print/RPrint', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            // 上传
            files(e) {
                let that = this;
                this.FileLists = [];
                this.fileparm.Code = e.row.exclusively_id;
                this.FileList.forEach(item => {
                    if (item.Code == e.row.exclusively_id) {
                        this.FileLists.push(item);
                    }
                })
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                this.isVisiblefile = true;
            },
            handleChange(file, fileList) {
                this.FileList = fileList.slice(-3);
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.getDetail(that.order_No);
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }
            },
            //删除文件
            filedel(row) {
                let that = this;
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.FileSrc == 'undefined' ? '' : row.row.FileSrc;
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.getDetail(that.order_No);
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            //打开文件
            open(row) {
                let that = this;
                // if (!that.$limits.fnIsEmpty(row.row.path)) {
                //     window.open(Common.Url + row.row.path);
                // }
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                console.log(parm);
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            // 上传(单据)
            filesH(e) {
                let that = this;
                this.FileListsH = [];
                this.fileparmH.Code = that.dataDetail.Head.order_no;
                this.FileListH.forEach(item => {
                    if (item.Code == that.dataDetail.Head.order_no) {
                        this.FileListsH.push(item);
                    }
                })
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparmH.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparmH.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
            },
            handleChangeH(file, fileList) {
                this.filesH()
                this.FileListH = fileList.slice(-3);
            },
            handleSuccessH(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.getDetail(that.order_No);
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }
            },
            //删除文件
            filedelH(row) {
                let that = this;
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.FileSrc == 'undefined' ? '' : row.row.FileSrc;
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.getDetail(that.order_No);
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            //打开文件
            openH(row) {
                let that = this;
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataDetailReturn != JSON.stringify(that.dataDetailReturn)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isShowReturn = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isShowReturn = false
                    callback(true)
                }
            },
            // 排序
            sortChange(column){
                let that = this
                let name = column.property
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataDetail.LineList.indexOf(obj1) - that.dataDetail.LineList.indexOf(obj2);
                        }
                    }
                    that.dataDetail.LineList.sort(compare);
                    that.dataDetail.LineList = [...that.dataDetail.LineList]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataDetail.LineList.indexOf(obj2) - that.dataDetail.LineList.indexOf(obj1);
                        }
                    }
                    that.dataDetail.LineList.sort(compare);
                    that.dataDetail.LineList = [...that.dataDetail.LineList]
                }
                that.sortRule.order = column.order
                that.sortRule.property = column.property
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 212,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.LineList.length; i++) {
                    delete datacopy.LineList[i]['index'];
                    delete datacopy.LineList[i]['_XID'];
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
